import React, { useState, useEffect, useContext } from 'react';
import { Sparkles, X } from 'lucide-react';
import { QuickQuoteContext } from '../LandingPage';

export default function FloatingCTA() {
  const openQuickQuote = useContext(QuickQuoteContext);
  const [show, setShow] = useState(false);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (closed) return;
      setShow(window.scrollY > 600);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [closed]);

  if (!show || closed) return null;

  return (
    <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 animate-fade-in" data-testid="floating-cta">
      <div className="bg-stone-950 border-2 border-primary rounded-lg shadow-2xl shadow-primary/20 overflow-hidden max-w-sm">
        <button
          onClick={() => setClosed(true)}
          aria-label="Chiudi"
          className="absolute top-2 right-2 text-stone-400 hover:text-white p-1 z-10">
          <X size={14} />
        </button>
        <button onClick={openQuickQuote} data-testid="floating-cta-btn" className="block text-left p-4 sm:p-5 group w-full">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-md bg-primary flex items-center justify-center flex-shrink-0">
              <Sparkles size={18} className="text-white" />
            </div>
            <div>
              <p className="text-[10px] font-black text-primary uppercase tracking-widest">Senza impegno</p>
              <p className="text-white font-black text-base leading-tight">Preventivo in 60 secondi</p>
              <p className="text-stone-400 text-xs mt-0.5 group-hover:text-primary transition-colors">Calcolalo gratis →</p>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
}
